import { ArrowRight } from 'lucide-react';
import {
  formatCurrency,
  formatDateKey,
  formatDateKeyFromMs,
  formatDisplayDate,
  formatDuration,
  formatTime,
} from '../../../utils/datetime';

const NextUpCard = ({ appointment, currency: businessCurrency, onArrive }) => {
  if (!appointment) {
    return (
      <div className="bg-ink-900 p-5 text-sand-50 sm:p-6">
        <p className="text-xs uppercase tracking-[0.22em] text-saffron-400">Next up</p>
        <h2 className="mt-2 font-display text-2xl font-light">No one waiting</h2>
        <p className="mt-2 max-w-md text-sm text-sand-200/75">
          No confirmed bookings in the next 3 months. When the next one is due, it will show here.
        </p>
      </div>
    );
  }

  const currency =
    appointment.currency || appointment.service?.currency || businessCurrency;
  const dateKey = formatDateKeyFromMs(appointment.startAt);
  const isToday = dateKey === formatDateKey();
  const whenLabel = isToday
    ? formatTime(appointment.startAt)
    : `${formatDisplayDate(dateKey)} · ${formatTime(appointment.startAt)}`;

  return (
    <div className="bg-ink-900 p-5 text-sand-50 sm:p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-[0.22em] text-saffron-400">Next up</p>
          <h2 className="mt-2 font-display text-3xl font-light tracking-tight">
            {appointment.client?.name || 'Client'}
          </h2>
          <p className="mt-2 text-sm text-sand-200/80">
            {whenLabel}
            {appointment.service?.name ? ` · ${appointment.service.name}` : ''}
            {appointment.service?.durationMinutes
              ? ` · ${formatDuration(appointment.service.durationMinutes)}`
              : ''}
            {appointment.staff?.name ? ` · ${appointment.staff.name}` : ''}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-3">
            <span className="bg-sand-50/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-sand-100 ring-1 ring-sand-100/20">
              {(appointment.status || 'confirmed').replace('_', ' ')}
            </span>
            <span className="text-sm text-sand-100">
              {formatCurrency(appointment.price || appointment.service?.price || 0, currency)}
            </span>
          </div>
        </div>
        {appointment.status === 'confirmed' && isToday && (
          <button
            type="button"
            onClick={() => onArrive?.(appointment.id)}
            className="inline-flex flex-none items-center justify-center gap-2 bg-saffron-500 px-5 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-ink-900 transition-colors hover:bg-saffron-400"
          >
            Mark arrived
            <ArrowRight className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default NextUpCard;
